var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scoped-notification-container" }, [
    _c(
      "div",
      {
        staticClass: "scoped-notification",
        class: `scoped-notification--${_vm.type}`
      },
      [
        _c("span", {
          staticClass: "scoped-notification__icon",
          domProps: { innerHTML: _vm._s(_vm.icon) }
        }),
        _vm._v(" "),
        _c("span", { domProps: { innerHTML: _vm._s(_vm.message) } })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }